import { Container, CssBaseline, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useContext } from 'react';

import { useI18n } from '../../../application/language/useI18n';
import { Colors } from '../../../view/design/color/Colors';
import { MainLayoutBottomLogoMenu } from '../../../view/layout/main/parts/LeftNavigation/parts/MainLayoutBottomLogoMenu';
import {
  ErrorPageOrganization,
  isShowOnlyEmail,
} from '../../../view/layout/main/parts/LeftNavigation/parts/MainLayoutLeftNavigationTopLogo';
import { ContainerContext } from '../../container/ContainerContext';

const PageServiceNotAvailable = () => {
  const context = useContext(ContainerContext);
  const ReqEduLogoComponent = context.get(MainLayoutBottomLogoMenu);
  const ErrorPageOrganizationContent = context.get(ErrorPageOrganization);
  const isShowOnlyEmailValue = context.get(isShowOnlyEmail)();
  const { translate, getCurrentLanguage } = useI18n();
  const classes = useStyles();

  return (
    <>
      <CssBaseline />
      <Container disableGutters maxWidth={false}>
        <Typography className={classes.background}>
          <Typography className={classes.topIcons} style={{ width: getCurrentLanguage() === 'ru' ? '220px' : '370px' }}>
            <ReqEduLogoComponent />
          </Typography>

          <Typography>
            <img src="/pictures/errorConnection.png" />
          </Typography>

          <Typography variant="h3" className={classes.headlineText}>
            {translate('serviceUnavailable.title')}
          </Typography>

          <Typography variant="h6" className={classes.mainText}>
            {translate('serviceUnavailable.message')}
          </Typography>

          {!isShowOnlyEmailValue && (
            <div className={classes.bottomContainer}>
              <div className={classes.supportText}>
                <div className={classes.supportRegular}>{translate('errorPage.writeUs')}</div>

                <div className={classes.supportBold}>
                  {getCurrentLanguage() === 'ru' ? 'support@startx.team' : 'support@humanfactor.ai'}
                </div>
              </div>

              {getCurrentLanguage() === 'ru' && (
                <div className={classes.supportText}>
                  <div className={classes.supportRegular}>{translate('errorPage.orCall')}</div>

                  <div className={classes.supportBold}>+7 499 677 19 07</div>
                </div>
              )}
            </div>
          )}
          {isShowOnlyEmailValue && (
            <div className={classes.onlyEmailContainer}>
              <div className={classes.supportText}>
                <div className={classes.supportRegular}>{translate('errorPage.writeUs')}</div>

                <div className={classes.supportBold}>ask@humanfactor.ai</div>
              </div>
            </div>
          )}
          <Typography variant="body2" className={classes.footerText}>
            {ErrorPageOrganizationContent(getCurrentLanguage())} {new Date().getFullYear()}
          </Typography>
        </Typography>
      </Container>
    </>
  );
};

export default PageServiceNotAvailable;

const useStyles = makeStyles((theme: Theme) => ({
  background: {
    margin: '0',
    padding: '20px 0',
    background: `${Colors.bg} !important`,
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  topIcons: {
    paddingBottom: '20px',
  },
  mainText: {
    width: '480px',
    color: Colors.textPrimary,
    textAlign: 'center',
    paddingBottom: '30px',
  },
  headlineText: {
    color: Colors.textPrimary,
    fontWeight: 'bold',
    fontSize: '48px',
    textAlign: 'center',
    paddingTop: '40px',
    paddingBottom: '16px',
  },
  footerText: {
    color: Colors.textDisabled,
    fontSize: '12px',
    fontWeight: '200',
    marginTop: 'auto',
    paddingTop: '20px',
  },
  bottomContainer: {
    display: 'flex',
    maxWidth: '900px',
    width: '100%',
    justifyContent: 'center',
    gap: 16,
  },
  onlyEmailContainer: { display: 'flex', maxWidth: '900px', width: '100%', justifyContent: 'center' },
  supportText: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '32.02px',
    padding: '16px',
    whiteSpace: 'nowrap',
  },
  supportBold: {
    color: Colors.textPrimary,
  },
  supportRegular: {
    color: Colors.textSecondary,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
}));
